import { createContext, useContext } from 'react';

const DEMO_STORAGE_KEY = 'demo-mode';

// Synchronous getter — safe to use outside the React tree (e.g. API mutator, useState initializer)
const getDemoMode = (): boolean => localStorage.getItem(DEMO_STORAGE_KEY) === 'true';

interface DemoContextType {
  isDemo: boolean;
  activateDemo: () => void;
  deactivateDemo: () => void;
}

const DemoContext = createContext<DemoContextType | null>(null);

const useDemoContext = (): DemoContextType => {
  const context = useContext(DemoContext);
  if (!context) throw new Error('useDemoContext must be used within DemoProvider');
  return context;
};

export { DemoContext, getDemoMode, useDemoContext, DEMO_STORAGE_KEY };
export type { DemoContextType };
